import React, { useEffect, useState } from "react";
import {
  Grid,
  Box,
  Typography,
  //useTheme,
  Button,
  useMediaQuery,
} from "@mui/material";
import mobileTopArc from "assets/images/mobile-top-curve.svg";
import mobileBottom from "assets/images/mobile-bottom-curve.svg";
import PartnerLogo from "assets/images/partner-logo.png";
import CuverdLogo from "assets/images/cuverd-logo-header.png";
import ProfessionalLogo from "assets/images/professional-logo.png";
import { homeActions } from "actions";
import { connect } from "react-redux";
import MessageDialog from "./SearchMedication/MessageDialog";

const Unsubscribe = (props) => {
  const {
    getCommunicationPreferences,
    preferredCommInfo,
    preferredCommResponse,
    savedPreferredCommInfo,
    saveCommunicationPreferences,
    organizationInfo,
  } = props;
  const [showSuccess, setShowSuccess] = useState(false);
  const [showFailure, setShowFailure] = useState(false);
  //const theme = useTheme();
  const matchesMinWidth = useMediaQuery("(max-width:600px)");
  const encryptedUser = window.location.href.split("encuser=")[1];
   

  const Logo =
    organizationInfo?.app?.appCode === "CVD"
      ? CuverdLogo
      : organizationInfo?.app?.appCode === "HCP"
      ? ProfessionalLogo
      : PartnerLogo;

  useEffect(() => {
    if (encryptedUser) {
      getCommunicationPreferences(encryptedUser);
    }
  }, [encryptedUser]);

  useEffect(() => {
    if (
      preferredCommResponse &&
      Object.keys(preferredCommResponse).length &&
      !preferredCommResponse.success
    ) {
      setShowFailure(true);
    }
  }, [preferredCommResponse]);

  useEffect(() => {
    if (savedPreferredCommInfo) {
      setShowSuccess(true);
    }
  }, [savedPreferredCommInfo]);

  // const disableStatus = () => {
  //   const anyCheckedVals =
  //     prefResult.length && prefResult.filter((item) => item.value === "OPT-IN");
  //   return anyCheckedVals?.length ? false : true;
  // };

  const onFormSubmit = () => {
    const params = { encUser: encryptedUser, data: {} };
    // prefResult.forEach((pair) => {
    //   params.data[pair.key] = pair.value;
    // });
    saveCommunicationPreferences(params);
  };

  return (
    <Box sx={{ position: "relative", height: "100vh" }}>
      <Box>
        <img
          src={mobileBottom}
          alt="mobile-arc"
          className="left-arc"
          style={{ width: "30%" }}
        />
      </Box>
      <Box>
        <img
          src={mobileTopArc}
          alt="mabile-arc"
          style={{ width: "30%", position: "absolute", right: 0, bottom: 0 }}
        />
      </Box>
      <Box sx={{ paddingLeft: "24px", paddingRight: "24px" }}>
        <Grid
          container
          pt={4}
          sx={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Box>
            <form>
              <Grid item container direction="column" alignItems="center">
                <Grid item>
                  <Box
                    sx={{
                      width: matchesMinWidth ? "80px" : "120px",
                      margin: "auto",
                    }}
                  >
                    <img src={Logo} style={{ width: "100%" }} alt="home-logo" />
                  </Box>
                </Grid>
                <Grid
                  item
                  sx={{
                    marginTop: matchesMinWidth ? "35px" : "35px",
                    marginBottom: matchesMinWidth ? "20px" : "20px",
                  }}
                >
                  <Box sx={{ textAlign: "center" }}>
                    <Typography
                      variant="h1LatoBlack"
                      sx={{ fontSize: matchesMinWidth ? "30px" : undefined }}
                    >
                      Unsubscribe
                    </Typography>
                  </Box>
                </Grid>
                <Grid item xs={12} sm={12} mb={0}>
                  <Box mt={1} mb={2} sx={{ textAlign: "center" }}>
                    <Typography variant="h3LatoBlack">
                      {preferredCommInfo && preferredCommInfo.email}
                    </Typography>
                  </Box>
                </Grid>

                <Grid item xs={12} sm={12}>
                  <Box mt={1}>
                    <Button
                      variant="large"
                      onClick={() => onFormSubmit()}
                      // disabled={disableStatus()}
                    >
                      UNSUBSCRIBE ME
                    </Button>
                  </Box>
                </Grid>
              </Grid>
            </form>
            {showSuccess ? (
              <MessageDialog showPopUp={showSuccess}>
                <Box>
                  <Box mt={1}>
                    <Typography variant="h3LatoBlack">
                      {preferredCommInfo && preferredCommInfo.email}
                    </Typography>
                  </Box>
                  <Box mt={4} mb={5}>
                    <Typography variant="h4LatoBold" sx={{ color: "#607277" }}>
                      {savedPreferredCommInfo &&
                        savedPreferredCommInfo?.message}
                    </Typography>
                  </Box>
                  <Box mb={3}>
                    <Button
                      variant="large"
                      onClick={() => {
                        setShowSuccess(false);
                      }}
                    >
                      OK
                    </Button>
                  </Box>
                </Box>
              </MessageDialog>
            ) : null}
            {showFailure ? (
              <MessageDialog showPopUp={showFailure}>
                <Box>
                  <Box sx={{ maxWidth: "400px" }}>
                    <Typography
                      variant={matchesMinWidth ? "h3LatoBold" : "h2LatoBold"}
                      sx={{ lineHeight: matchesMinWidth ? "24px" : "26px" }}
                    >
                      {preferredCommResponse?.message}
                    </Typography>
                  </Box>
                  <Box mt={5}>
                    <Button
                      variant="large"
                      onClick={() => {
                        setShowFailure(false);
                      }}
                    >
                      DONE
                    </Button>
                  </Box>
                </Box>
              </MessageDialog>
            ) : null}
          </Box>
        </Grid>
      </Box>
    </Box>
  );
};

// export default Unsubscribe;
const mapStateToProps = (state) => {
  return {
    preferredCommInfo: state.preferredCommInfo.data,
    preferredCommResponse: state.preferredCommInfo.result,
    savedPreferredCommInfo: state.savedPreferredCommInfo.data,
    organizationInfo: state.organizationInfo.data,
  };
};

const mapDispatchToProps = {
  getCommunicationPreferences: (params) =>
    homeActions.getCommunicationPreferences(params),
  saveCommunicationPreferences: (params) =>
    homeActions.saveCommunicationPreferences(params),
};

export default connect(mapStateToProps, mapDispatchToProps)(Unsubscribe);
